import { useMutation } from '@tanstack/react-query';

import { useEndFlowModal } from '@/contexts/endFlowModalContext';

import { createManySalaries, createSalary } from '../functions/salaries';

export const useCreateSalary = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationFn: createSalary,
    mutationKey: ['create-salary'],
    onError: (e: any) => {
      showError({});
      console.error('Error creating salary', e);
    }
  });
};

export const useCreateManySalaries = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationFn: createManySalaries,
    mutationKey: ['create-many-salaries'],
    onError: (e: any) => {
      showError({});
      console.error('Error creating salaries', e);
    }
  });
};
